import styled from 'styled-components';

const MainContainer = styled.div`
  width: 90%;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    width: 96%;
  }
`;

export default MainContainer;
